module.exports = __webpack_public_path__ + "img/BG3-icon.1f7a23e5.png";